import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import '@/scss/vuetify/overrides.scss'
Vue.use(Vuetify);

var theme = {
    primary: '#1e88e5',
    info: '#1e88e5',
    success: '#21c1d6',
    accent: '#fc4b6c',
    default: '#563dea',
    spreadsheet: '#4f9d49'
}

switch(process.env.VUE_APP_INSTANCE) {
    case "hdh":
        theme['avgidea'] = '#ffffff';
        break;
    case "d-ocean":
        // theme['avgidea'] = '#02075F';
        theme['avgidea'] = '#1E90FF';
        break;
    default:
        theme['avgidea'] = '#e89a37';
}

export default new Vuetify({
    theme: {
        themes: {
          dark: theme,
          light: theme,
        },
      }
});
